"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
exports.CHANGE_MAIN_STEP = "CHANGE_MAIN_STEP";
exports.SAVE_PROJECT_INFO = "SAVE_PROJECT_INFO";
exports.SAVE_PROJECT_INIT_DATA = "SAVE_PROJECT_INIT_DATA";
exports.SAVE_COLUMN_SELECTIONS22 = "SAVE_COLUMN_SELECTIONS22";
exports.NULL_VALUE_COLUMNS = "NULL_VALUE_COLUMNS";
exports.SAVE_COLUMN_SELECTIONS32 = "SAVE_COLUMN_SELECTIONS32";
exports.SAVE_HANDLING_MISSING_VALUES = "SAVE_HANDLING_MISSING_VALUES";
exports.SAVE_INTERPOLATION_DATA = "SAVE_INTERPOLATION_DATA";
exports.SAVE_LAG_VARIABLES = "SAVE_LAG_VARIABLES";
exports.SAVE_OUTLIER_VISUALIZATIONS = "SAVE_OUTLIER_VISUALIZATIONS";
exports.SAVE_CSV_DATAS21 = "SAVE_CSV_DATAS21";
exports.SAVE_CSV_DATAS24 = "SAVE_CSV_DATAS24";
exports.SAVE_FEATURE_SELECTIONS = "SAVE_FEATURE_SELECTIONS";
exports.SAVE_SAMPLING_METHOD = "SAVE_SAMPLING_METHOD";
exports.SAVE_TRAIN_TEST_RATIO = "SAVE_TRAIN_TEST_RATIO";
exports.SAVE_FINAL_DATA = "SAVE_FINAL_DATA";
exports.UPDATE_BINARY_THRESHOLDING_DATA = "UPDATE_BINARY_THRESHOLDING_DATA";
exports.FEATURE_MAPPING_DATA = "FEATURE_MAPPING_DATA";
exports.SAVE_FINAL_UNIQUE_COLUMNS = "SAVE_FINAL_UNIQUE_COLUMNS";
exports.SAVE_DATA_TRANSFORM_RSA_MS = "SAVE_DATA_TRANSFORM_RSA_MS";
exports.SAVE_MODEL_SELECTION = "SAVE_MODEL_SELECTION";
exports.SAVE_GRAPH_PATH = "SAVE_GRAPH_PATH";
exports.RESET_UNWHITELISTED_STATE = "RESET_UNWHITELISTED_STATE";
exports.changeMainStep = (payload) => ({
    type: exports.CHANGE_MAIN_STEP,
    payload,
});
exports.saveProjectInfo = (payload) => ({
    type: exports.SAVE_PROJECT_INFO,
    payload,
});
exports.saveProjectInitiationData = (payload) => ({
    type: exports.SAVE_PROJECT_INIT_DATA,
    payload,
});
exports.saveColumnSelectionS22 = (payload) => ({
    type: exports.SAVE_COLUMN_SELECTIONS22,
    payload,
});
exports.nullValueColumns = (payload) => ({
    type: exports.NULL_VALUE_COLUMNS,
    payload,
});
exports.saveColumnSelectionS32 = (payload) => ({
    type: exports.SAVE_COLUMN_SELECTIONS32,
    payload,
});
exports.saveHandlingMissingValues = (payload) => ({
    type: exports.SAVE_HANDLING_MISSING_VALUES,
    payload,
});
exports.saveInterpolationData = (payload) => ({
    type: exports.SAVE_INTERPOLATION_DATA,
    payload,
});
exports.saveLagVariables = (payload) => ({
    type: exports.SAVE_LAG_VARIABLES,
    payload,
});
exports.saveOutlierVisualizations = (payload) => ({
    type: exports.SAVE_OUTLIER_VISUALIZATIONS,
    payload,
});
exports.saveCSVDataS21 = (payload) => ({
    type: exports.SAVE_CSV_DATAS21,
    payload,
});
exports.saveFeatureSelections = (payload) => ({
    type: exports.SAVE_FEATURE_SELECTIONS,
    payload,
});
exports.saveSamplingMethod = (payload) => ({
    type: exports.SAVE_SAMPLING_METHOD,
    payload,
});
exports.saveTrainTestRatio = (payload) => ({
    type: exports.SAVE_TRAIN_TEST_RATIO,
    payload,
});
exports.saveFinalData = (payload) => ({
    type: exports.SAVE_FINAL_DATA,
    payload,
});
exports.updateBinaryThresholdingData = (payload) => ({
    type: "UPDATE_BINARY_THRESHOLDING_DATA",
    payload,
});
exports.saveFeatureMappingData = (payload) => ({
    type: "FEATURE_MAPPING_DATA",
    payload
});
exports.saveFinalUniqueColumns = (payload) => ({
    type: exports.SAVE_FINAL_UNIQUE_COLUMNS,
    payload,
});
exports.saveDataTransFormRcaMs = (payload) => ({
    type: exports.SAVE_DATA_TRANSFORM_RSA_MS,
    payload
});
exports.saveModelSelection = (payload) => ({
    type: exports.SAVE_MODEL_SELECTION,
    payload
});
exports.saveGraphPath = (payload) => ({
    type: exports.SAVE_GRAPH_PATH,
    payload
});
//# sourceMappingURL=actions.js.map